import { render, staticRenderFns } from "./ImageHotspotsEditor.vue?vue&type=template&id=2799be62&scoped=true"
import script from "./ImageHotspotsEditor.vue?vue&type=script&lang=js"
export * from "./ImageHotspotsEditor.vue?vue&type=script&lang=js"
import style0 from "./ImageHotspotsEditor.vue?vue&type=style&index=0&id=2799be62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799be62",
  null
  
)

export default component.exports